
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'DirectionsBannerBlock',

  computed: {
    videoUrl: function () {
      if (process.client && window.innerWidth <= 1023) {
        return ''
      }

      if (!this.values?.video) {
        return ""
      }
      return `${ this.$nuxt?.context?.env?.baseApiUrl }/api/storage/file/${ this.values.video }`
    },
    isMobileImage: function () {
      return Boolean(this.values?.image_mobile)
    },
    htmlComponentTitle: function () {
      if (String(this.cfgs?.use_h1 || "0") === "1") {
        return "h1"
      }
      return "h2"
    }
  },

  mounted: function () {
    this.startVideo();
  },

  methods: {
    leaveRequest: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          type: this.values?.form_type || 'Заказать звонок',
          hideTabs: true,
          miniReachGoal: this.values.reach_goal,
          fullReachGoal: this.values.reach_goal,
        }
      });
    },
    startVideo: function () {
      if (!this.videoUrl) {
        return
      }
      if (!this.$refs.refVideo) {
        setTimeout(() => {
          this.startVideo();
        }, 500);
        return;
      }
      // preload="metadata": перед play() страхуемся, что браузер начал загрузку ресурса
      if (this.$refs.refVideo.readyState === 0) { this.$refs.refVideo.load(); }
      const playPromise = this.$refs.refVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') { playPromise.catch(() => {}); }
    },
  }
});
